<template>
  <div id="app">
    <navigation />
    <router-view/>
  </div>
</template>
<script>
import Navigation from './Navigation.vue'

export default {
  name: 'App',
  components: {
    Navigation
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
